var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartWithBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59766 9.49922L4.87266 8.84922C4.03099 8.09089 3.33516 7.43672 2.78516 6.88672C2.23516 6.33672 1.79766 5.84289 1.47266 5.40522C1.14766 4.96755 0.920656 4.56555 0.791656 4.19922C0.662656 3.83289 0.59799 3.45789 0.597656 3.07422C0.597656 2.29089 0.860156 1.63672 1.38516 1.11172C1.91016 0.586719 2.56432 0.324219 3.34766 0.324219C3.78099 0.324219 4.19349 0.415885 4.58516 0.599219C4.97682 0.782552 5.31432 1.04089 5.59766 1.37422C5.88099 1.04089 6.21849 0.782552 6.61016 0.599219C7.00182 0.415885 7.41432 0.324219 7.84766 0.324219C8.63099 0.324219 9.28516 0.586719 9.81016 1.11172C10.3352 1.63672 10.5977 2.29089 10.5977 3.07422C10.5977 3.45755 10.5332 3.83255 10.4042 4.19922C10.2752 4.56589 10.048 4.96789 9.72266 5.40522C9.39732 5.84255 8.95982 6.33639 8.41016 6.88672C7.86049 7.43705 7.16466 8.09122 6.32266 8.84922L5.59766 9.49922Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWithBlack);
export default __webpack_public_path__ + "static/media/heartWithBlack.4c0536dd7f304c1695b626787f196271.svg";
export { ForwardRef as ReactComponent };